import { useState } from 'react';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  Button,
} from '@/components/atoms';
import { FileTextIcon } from 'lucide-react';
import { AskSellytModal } from './ask-sellyt-modal';
import type { Article } from '@/types';

interface ArticleModalProps {
  isOpen: boolean;
  onClose: () => void;
  article: Article | null;
}

export const ArticleModal = ({
  isOpen,
  onClose,
  article,
}: ArticleModalProps) => {
  const [askSellytOpen, setAskSellytOpen] = useState(false);

  const handleContactSales = () => {
    setAskSellytOpen(true);
  };

  return (
    <Sheet open={isOpen} onOpenChange={onClose}>
      <SheetContent side="right" className="w-full sm:max-w-4xl">
        <SheetHeader>
          <SheetTitle className="flex items-center gap-2">
            <FileTextIcon className="w-5 h-5 text-primary" />
            {article?.title}
          </SheetTitle>
        </SheetHeader>
        <div className="p-4 overflow-y-auto flex-1">
          <div className="prose max-w-none">
            <div
              dangerouslySetInnerHTML={{
                __html: (article?.content ?? '').replace(/\n/g, '<br/>') || '',
              }}
            />
          </div>
        </div>
        <div className="grid gap-3 p-4">
          <Button
            className="bg-primary text-white"
            onClick={handleContactSales}
          >
            Contact sales
          </Button>
          <Button variant="outline" onClick={onClose}>
            Close
          </Button>
        </div>
      </SheetContent>

      {/* Ask Sellyt Modal */}
      <AskSellytModal
        isOpen={askSellytOpen}
        onClose={() => setAskSellytOpen(false)}
      />
    </Sheet>
  );
};
